import * as cookie from 'es-cookie';
import CESAppInfo from './CESAppInfo';
import { convert64 } from "./CESUtils";

const sessionUserNameKey = "cds-current-user";
const sessionUserIdKey = "cds-current-user-uuid";
const sessionHashedKocIdKey = "cds-current-user-hashed-kocid";
const accessTokenKey = "cds-current-user-token";
const refreshTokenKey = "cds-current-user-token-refresh";

/**
 * Represents an user object in CES activities.
 */
class CESUser {
  private name: string = '';
  private email: string = '';
  private userID: string = '';

  setUser(name?: string, email?: string, userID?: string) {
    this.name = name || '';
    this.email = email || '';
    this.userID = userID || '';
  }

  updateUser(name?: string, email?: string) {
    this.name = name || '';
    this.email = email || '';
  }

  setName(name: string) {
    this.name = name;
  }


  getName() {
    return this.name;
  }

  persist(userInfo: object) {
    const encodedUser = convert64(JSON.stringify(userInfo));
    sessionStorage.setItem(sessionUserNameKey, encodedUser);
  }

  getHashedKocid() {
    return sessionStorage.getItem(sessionHashedKocIdKey);
  }


  setHashedKocid(hashedKocid: string) {
    const encodedHashedKocid = convert64(hashedKocid);
    sessionStorage.setItem(sessionHashedKocIdKey, encodedHashedKocid);

  }

  setUserId(id: string) {
    this.userID = id;
    sessionStorage.setItem(sessionUserIdKey, convert64(id));
  }

  getUserId() {
    return this.userID;
  }

  getEmail() {
    return this.email;
  }

  setEmail(email: string) {
    this.email = email;
  }

  clear() {
    if (CESAppInfo.socialSettings?.useRedirect) {
      sessionStorage.removeItem(accessTokenKey);
      sessionStorage.removeItem(refreshTokenKey);
    } else {
      cookie.remove(accessTokenKey);
      cookie.remove(refreshTokenKey);
    }

    sessionStorage.removeItem(sessionUserIdKey);
    sessionStorage.removeItem(sessionHashedKocIdKey); // Remove hashedKocid from sessionStorage
  }

  getProperties(data: any) {
    if (Object.prototype.hasOwnProperty.call(data.user, "email")) {
      this.setEmail(data.email);
    }


    if (Object.prototype.hasOwnProperty.call(data.user, "familyName")) {
      const name = this.getName();
      this.setName(`${name} ${data.givenName}`);
    }

    if (Object.prototype.hasOwnProperty.call(data.ciam, "uuid")) {
      this.setUserId(data.ciam.uuid);
    }
    if (Object.prototype.hasOwnProperty.call(data.ciam, "hashedKocid")) {
      const hashedKocid = data.ciam.hashedKocid;
      this.setHashedKocid(hashedKocid); // Set the hashedKocid
    }
  }

  /**
   * Sets the cookie for the access token
   */
  setAccessToken(data: string) {
    if (CESAppInfo.socialSettings?.useRedirect) {
      sessionStorage.setItem(accessTokenKey, data);
    } else {
      cookie.set(accessTokenKey, data, { secure: true });
    }
  }

  /**
 * Sets the cookie for the refresh token
 */
  setRefreshToken(data: string) {
    if (CESAppInfo.socialSettings?.useRedirect) {
      sessionStorage.setItem(refreshTokenKey, data);
    } else {
      cookie.set(refreshTokenKey, data, { secure: true });
    }
  }

  /**
   * Sets the cookie for the access token
   */
  getAccessToken() {
    if (CESAppInfo.socialSettings?.useRedirect) {
      return sessionStorage.getItem(accessTokenKey);
    }

    return cookie.get(accessTokenKey);
  }

  /**
   * Sets the cookie for the refresh token
   */
  getRefreshToken() {
    if (CESAppInfo.socialSettings?.useRedirect) {
      return sessionStorage.getItem(refreshTokenKey);
    }
    return cookie.get(refreshTokenKey);
  }
}

export default new CESUser();